"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));
var _commonUtils = require("@sial/common-utils");
var _meta = require("../_utils/meta");
var _errorMessages = require("../_utils/error-messages");
var _RelatedContentCard = require("../RelatedContentCard");
var _LinkWrapper = _interopRequireDefault(require("../RelatedContentCard/LinkWrapper"));
var _Text = _interopRequireDefault(require("../Text"));
var _excluded = ["type", "heading", "ctaTitle", "ctaLink", "content"];
var __jsx = _react.default.createElement;
var isAemEditMode = (0, _meta.getWcmmode)() === 'edit';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    heading: {
      '&$heading': {
        marginBottom: theme.spacing(5.5)
      }
    },
    ctaLink: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1.53,
      '&$ctaLink': {
        fontWeight: theme.typography.fontWeightBold
      }
    },
    icon: {
      verticalAlign: 'bottom'
    },
    linkList: {
      margin: '0',
      padding: '0',
      listStyleType: 'none',
      '& > li': {
        margin: theme.spacing(3, 0)
      }
    }
  };
});
var PrimaryContentColumn = function PrimaryContentColumn(_ref) {
  var type = _ref.type,
    heading = _ref.heading,
    ctaTitle = _ref.ctaTitle,
    ctaLink = _ref.ctaLink,
    content = _ref.content,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var classes = useStyles();
  var isGTMEnabled = function isGTMEnabled() {
    var _window;
    return typeof window !== 'undefined' && ((_window = window) === null || _window === void 0 ? void 0 : _window.dataLayer);
  };
  var action = typeof window !== 'undefined' ? "".concat(window.location.origin).concat(ctaLink) : _commonUtils.EventValues.NotAvailable;
  var label = typeof window !== 'undefined' ? "".concat(ctaTitle, " | ").concat(window.location.href) : _commonUtils.EventValues.NotAvailable;
  var trackSeeAllClickEventGA = function trackSeeAllClickEventGA() {
    if (!isGTMEnabled) return;
    _commonUtils.Analytics.sendGTMEvent({
      eventType: _commonUtils.GTMEventTypes.AnalyticsEvent,
      payload: {
        eventCategory: _commonUtils.GTMEventCategory.InsiteLinkClick.toLowerCase(),
        eventAction: action.toLowerCase(),
        eventLabel: label.toLowerCase(),
        eventInteractionType: 0
      }
    });
  };
  return __jsx(_react.default.Fragment, null, heading && __jsx(_core.Typography, {
    component: "h2",
    className: classes.heading,
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), type === 'text' && __jsx(_Text.default, {
    text: content,
    richText: true
  }), type === 'links' && (content || ctaTitle && ctaLink) && __jsx("ul", {
    className: classes.linkList
  }, content && Array.isArray(content) && content.map(function (linkProps, index) {
    // is edit mode && contain errors
    if (isAemEditMode && linkProps.errorMessage) {
      var errorMessage = (0, _errorMessages.linkError)(linkProps.url, linkProps.errorMessage);
      return __jsx("li", null, errorMessage);
    }
    // title is not null && does not contain error
    if (linkProps.title && !linkProps.errorMessage) {
      return __jsx("li", {
        key: index
      }, __jsx(_RelatedContentCard.RelatedContentCard, (0, _extends2.default)({}, linkProps, {
        maxTitleLines: 1,
        maxTextLines: 2
      })));
    }
    // title is null & we are in edit mode
    if (isAemEditMode) {
      var _errorMessage = (0, _errorMessages.linkError)(linkProps.url);
      return __jsx("li", null, _errorMessage);
    }
    // title is null & we are not in edit mode
    return null;
  }), ctaTitle && ctaLink && __jsx("li", null, __jsx(_LinkWrapper.default, {
    href: ctaLink,
    className: classes.ctaLink,
    handleLinkClick: trackSeeAllClickEventGA
  }, ctaTitle, __jsx(_ChevronRight.default, {
    className: classes.icon
  })))));
};
var _default = PrimaryContentColumn;
exports.default = _default;